import type { FC } from 'react';

import Box from '@mui/material/Box';

import TicketInfo from '@/views/apps/ticket/view/TicketInfo';
import type { EntityComponentProps } from '../../types/EntityComponent.types';

const TicketEntityContent: FC<EntityComponentProps> = ({ data }) => {
    return (
        <Box>
            <TicketInfo data={data} />
        </Box>
    );
};

export default TicketEntityContent;
